'use client';

import { useCallback } from 'react';
import { isRestaurantOpen, checkTechnicalBreak } from '@/lib/business-hours';
import { useAddressStore } from '@/stores/address-store';
import { useCheckoutStore, selectDeliveryTime } from '@/stores/checkout-store';
import { toast } from 'sonner';

export function useOrderAvailability() {
  const selectedAddress = useAddressStore((s) => s.selectedAddress);
  const deliveryTime = useCheckoutStore(selectDeliveryTime);

  /**
   * Проверка перед оплатой.
   * - Если выбрано "как можно быстрее", а ресторан закрыт — блокируем.
   * - Техперерыв — блокируем.
   * - Предзаказ на конкретное время — всегда пропускаем.
   */
  const checkAvailability = useCallback(async (): Promise<boolean> => {
    // 1. "Как можно быстрее" доступно только в рабочее время (11:00–22:00,
    //    см. OPEN_HOUR/CLOSE_HOUR в lib/business-hours.ts)
    if (deliveryTime.type === 'now' && !isRestaurantOpen()) {
      toast.error('Сейчас доставка не работает. Выберите время предзаказа.');
      return false;
    }

    // 2. Техперерыв на точке доставки
    if (selectedAddress?.deliveryPointId) {
      const onBreak = await checkTechnicalBreak(selectedAddress.deliveryPointId);
      if (onBreak) {
        toast.error('Чтобы не подводить Вас, мы временно приостановили приём заказов. Попробуйте чуть позже.');
        return false;
      }
    }

    return true;
  }, [deliveryTime.type, selectedAddress?.deliveryPointId]);

  return { checkAvailability };
}
